export default __webpack_public_path__ + "static/media/natan.37d22aa0.png";